export enum EFilterEventName {
  OnChange = 'onChange',

  onSearch = 'onSearch'
}



// WEBPACK FOOTER //
// ./src/components/OYFilter/enum.ts